import * as User from './user';
import * as Notification from './notification';
import * as Chat from './chat';
import * as Comm from './comm';
import * as Project from './project';
import * as Download from './download';
import * as Setting from './setting';
import * as Thirdparty from './thirdparty';
import * as Window from './window';
import * as Capture from './capture';
import * as Login from './login';
import * as AlarmWidget from './alarmWidget';

export const ElectronApi = (() => {
    return {
        Comm,
        User,
        Notification,
        Chat,
        Project,
        Download,
        Setting,
        Thirdparty,
        Window,
        Capture,
        Login,
        AlarmWidget,
    }
})();
